<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="500"
    >
        <v-card>
            <v-btn
            icon
            absolute
            top
            right
            @click="$emit('closeModal')"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <br>
            <v-card-title class="d-flex justify-center">
                <p class="text-center primary--text">Bank Account Details</p>
            </v-card-title>
            <v-card-text>
                <div class="secondary pa-5 rounded dt-border" v-for="bank in banks" :key="bank.id">
                    <span v-if="bank.isDefault == true" class="absolute green--text" style="position:absolute;right:30px">Default</span>  
                    <p><b>Bank</b> : {{bank.bankName}}</p>
                    <p><b>Account Name</b> : {{bank.accountName}}</p>
                    <p><b>Account Number</b> : {{bank.nuban}}</p>
                    <p><b>Date Added </b> : {{formatDate(bank.created)}}</p>
                    <p><b>Paystack Recipient Code</b> : {{bank.paystackRecipientCode}}</p>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
// =========== IMPORT SERVICES ========
import { parseTimestamp } from '@/utils/dates'

export default {
    props:{
        dialog:{
            type:Boolean,
        },
        banks:{
            type:Array
        }
    },
    methods:{
        formatDate(date){
            return parseTimestamp(new Date(date), 'DD MMMM, HH:mm')
        }
    }
}
</script>